export default __webpack_public_path__ + "static/media/hero-main.6b7ec0cf.svg";